/* eslint-disable react/no-danger */
import React from 'react';

import { ModalNames } from 'common/module/ui/lazy-modal/constant-types';
import buildReactDomModalModule from 'common/module/ui/lazy-modal/react-dom-modal-module';
import ReactModal from 'common/module/ui/lazy-modal/react-modal';
import trans from 'common/tools/translations/trans';
import { getResendConfirmationEmailUrl } from 'common/tools/userspace';

const AccountNeedsConfirmationModal = () => {
  return (
    <ReactModal
      size="small"
      className="modal-welcome"
      title={trans('userspace.account-confirmation-need-modal.title')}
    >
      <p
        dangerouslySetInnerHTML={{
          __html: trans('userspace.account-confirmation-need-modal.text')
        }}
      />
      <a
        className="button button-inverse-full"
        href={getResendConfirmationEmailUrl()}
      >
        {trans('userspace.resend-activation-link')}
      </a>
    </ReactModal>
  );
};

export default buildReactDomModalModule(
  ModalNames.ACCOUNT_NEEDS_CONFIRMATION,
  () => <AccountNeedsConfirmationModal />
);
